import React from 'react';

import {CircularProgress} from "@mui/joy";
import Box from '@mui/joy/Box';

// components
import BaseApi from "../../utils/BaseApi";
import withRouter from "../../utils/withRouter";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import dayjs from "dayjs";
import {deleteArrayItemByKeyValue, objectFilter} from "../../utils/misc";


class WikiPageList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            wikiPages: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveWikiPages();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveWikiPages();
        }
    }

    async retrieveWikiPages() {
        const url = 'wiki_page/';
        const api = new BaseApi();
        let params = {}
        if (this.props.params.pageNumber){
            params['page'] = this.props.params.pageNumber;
        }
        params = {...params, ...this.state.filters};
        let response = await api.get(url, params);
        if (response.status === 404){
            params['page'] = 1;
        }
        response = await api.get(url, params);
        this.setState(
            {
                wikiPages: response.data.results,
                pages: response.data.total_pages,
            }
        );
    }


    render() {
        if (!this.state.wikiPages || !this.state.pages) {
            return (<CircularProgress/>)
        }
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    my: 1,
                    gap: 1,
                    flexWrap: 'wrap',
                    '& > *': {
                        minWidth: 'clamp(0px, (500px - 100%) * 999, 100%)',
                        flexGrow: 1,
                    },
                }}
            >
                <CommonPaginatedTable
                    title={'Wiki страницы'}
                    url={'wiki_page'}
                    data={this.state.wikiPages}
                    pages={this.state.pages}
                    pageNumber={this.props.params.pageNumber!==undefined?parseInt(this.props.params.pageNumber):1}
                    fields={[
                        {
                            title: 'Название',
                            name: 'title',
                            linkPattern: '/wiki_page/detail/:linkParam',
                            linkParam: 'id',
                            linkTarget: '_blank',
                            visible: true,
                        },
                        {
                            title: 'Slug',
                            name: 'slug',
                            visible: true,
                        },
                        {
                            title: 'Создано',
                            name: 'created_on',
                            visible: true,
                        },
                        {
                            title: 'Обновлено',
                            name: 'updated_on',
                            visible: true,
                        },
                    ]
                    }
                />
            </Box>
        )
    }
}

export default withRouter(WikiPageList)